import { Component } from 'opus-angular-seed-core';

@Component({
    require: {
        formRow: '^formRow'
    },
    template: `
        <p ng-if="vm.formRow.error" class="desc error">{{ vm.formRow.error }}</p>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/form/row/error/index.js